













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch, PropSync } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Mall, GetBrandsSearchRequest, NCPResponse } from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompCheckBox from '@/components/common/CompCheckBoxButton.vue';
import ClickOutside from 'vue-click-outside';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import ValidateInput from '@/components/common/input/ValidateInput.vue';
import {
  Mds,
  ContractedPartner,
  StandardCategory,
  StandardCategoriesTree,
  DisplayCategoriesView,
  DisplayCategoriesTree,
  Grade,
  Group,
  Brand,
  PaymentMean,
} from 'supporter';
import { getToday, addMonth } from '@/utils/dateUtils';
import { htmlRestore } from '@/utils/formatUtils';
import debounce from 'lodash.debounce';
import RadioGroup from '@/pro/components/common/RadioGroup.vue';
import DisplayOrderInfo from '@/pro/views/contents/product/basic/ProductAdd/basicInfo/details/DisplayOrderInfo.vue';
import { CONFIG_TYPE, SORT_CRITERION } from '@/pro/const/contents/product';
import { relatedProductRadioOption } from '@/pro/views/contents/product/basic/ProductAdd/basicInfo/BasicInfo';
import { RadioBoxGroupOption } from '@/pro/helpers/type';
import { RelatedProductInformation } from '@/pro/types';
const emojiRegex = require('emoji-regex');
const mallModule = namespace('mall');
@Component({
  components: {
    CompSelectBox,
    CompCheckBox,
    PeriodDateCalendar,
    RadioGroup,
    DisplayOrderInfo,
    ValidateInput
  },
  directives: {
    ClickOutside,
  },
})
export default class BasicInformation extends Vue {
  private useStandardCategorySelect: boolean = true;
  private useDisplayCategorySelect: boolean = true;
  @Prop({ required: true }) immutableFields!: string[];
  @Prop({ required: true }) useNaverPay!: boolean;
  @Prop({ required: true }) categoryCommissionUseYn!: boolean;
  @Prop({ required: true }) partner!: any;
  @Prop({ required: true }) error!: any;
  @Prop({ required: true }) admin!: any;
  @Prop({ required: true }) partners!: ContractedPartner[];
  private displayPartners: any[] = [];
  @Prop({ required: true }) admins!: Mds[];
  @Prop({ required: true }) firstInitDataChange!: boolean;
  private displayAdmins: any[] = [];
  @Prop({ required: true }) standardCategory!: StandardCategory;
  @Prop({ required: true }) displayCategoryNames!: any[];
  @Prop({ required: true }) private selectMallNo = false;

  @Prop({ required: true }) standardCategories!: StandardCategory[];
  private displayStandardCategories: any[] = [];
  @Prop({ required: true }) standardCategoriesTree!: StandardCategoriesTree[];
  private selectedStandardCategory1Depth: StandardCategoriesTree | null = null;
  private selectedStandardCategory2Depth: StandardCategoriesTree | null = null;
  private selectedStandardCategory3Depth: StandardCategoriesTree | null = null;
  private selectedStandardCategory4Depth: StandardCategoriesTree | null = null;
  private displayCategoryInput = '';
  private isPurchaseByMinorsTooltip = false
  private isBookCategory = false
  private categoryInput = '';
  @Prop({ required: true }) useMallAuth!: boolean;
  @Prop({ required: true }) displayCategories!: DisplayCategoriesView[];
  private displayDisplayCategories: any[] = [];
  @Prop({ required: true }) displayCategoriesTree!: DisplayCategoriesTree[];
  private selectedDisplayCategory1Depth: DisplayCategoriesTree | null = null;
  private selectedDisplayCategory2Depth: DisplayCategoriesTree | null = null;
  private selectedDisplayCategory3Depth: DisplayCategoriesTree | null = null;
  private selectedDisplayCategory4Depth: DisplayCategoriesTree | null = null;
  private selectedDisplayCategory5Depth: DisplayCategoriesTree | null = null;
  private displayUrlDirectDisplayYnHelp = false;

  private paymentMeansControl = [
    {
      name: 'paymentMeansControlYn_N',
      label: 'PRODUCT_COMMON_ALL_CAN',
      value: 'N',
    },
    {
      name: 'paymentMeansControlYn_paycoPoint',
      label: 'PRODUCT_ADD_PAYCO_POINT',
      value: 'PAYCO_POINT',
    },
    {
      name: 'paymentMeansControlYn_Y',
      label: 'COMMON_SETTING',
      value: 'Y',
    },
  ];

  @Prop({ required: true }) grades!: Grade[];
  @Prop({ required: true }) disableArea!: any;
  private checkGradeAll = true;

  @Prop({ required: true }) groups!: Group[];
  private checkGroupAll = true;
  @Prop({ required: true }) productNameEn!: any;
  private getToday = getToday();
  private get3MAfter = addMonth(new Date(), 3, '-');

  private brands: Brand[] = [];
  private displayBrands: any[] = [];
  @Prop({ required: true }) brand!: any;

  private paymentMeans: PaymentMean[] = [];
  private htmlRestore = htmlRestore;
  private regex = emojiRegex();

  @PropSync('relatedProductInfo', { required: true })
  private relatedProductInfoSync: RelatedProductInformation;

  private CONFIG_TYPE = CONFIG_TYPE;
  private relatedProductRadioOption: RadioBoxGroupOption<keyof typeof CONFIG_TYPE> = relatedProductRadioOption;

  @Prop({ required: true }) private product!: any;

  clickCheckGradeAll(e: Event) {
    const checked = (e.target as HTMLInputElement).checked;
    if (checked) {
      this.product.memberGradeDisplayInfo.info = [];
      this.grades.forEach(item => {
        this.product.memberGradeDisplayInfo.info.push(item.no);
      });
    } else {
      this.product.memberGradeDisplayInfo.info = [];
    }
  }
  /**
   * * 파트너사 변경 시 영향범위
   * * 배송구분이 파트너사배송일 경우 변경된 파트너사의 default 배송템플릿으로 설정. DeliveryInformation 함
   */
  @Watch('product.partnerNo')
  onPartnerNoChanged() {
    if (!this.product.partnerNo) {
      this.partner.partnerName = '';
    } else {
      // * 파트너가 프로모션 미동의(파트너사 조회 - promotionAgreed == false) 설정되어있을경우 프로모션 항목은 불가능으로 default 선택 (비활성화 X)
      if (this.partner) {
        if (!this.partner.agreePromotion && !this.firstInitDataChange) {
          this.product.promotionInfo.promotionYn = 'N';
        }
        // * 선택된 파트너의 commissionRate > 0 이면 판매수수료 를 파트너수수료로 선택 및 파트너수수료 노출
        if (
          this.partner.commissionRate &&
          this.$route.name !== 'EditProduct' &&
          this.$route.name !== 'CopyProduct' &&
          this.product.classType !== 'EVENT'
        ) {
          this.product.commissionInfo.type = 'PARTNER';
          this.product.commissionInfo.rate = this.partner.commissionRate;
        }
      }
    }
  }
  @Watch('product.adminNo')
  onAdminNoChanged() {
    if (!this.product.adminNo) {
      this.admin.adminName = '';
    }
  }
  @Watch('product.displayCategoryNos')
  onDisplayCategoryNosChanged() {
    if (!this.product.displayCategoryNos.length) {
      this.displayCategoryNames.length = 0;
      this.useDisplayCategorySelect = true;
      this.selectedDisplayCategory1Depth = null;
      this.selectedDisplayCategory2Depth = null;
      this.selectedDisplayCategory3Depth = null;
      this.selectedDisplayCategory4Depth = null;
      this.selectedDisplayCategory5Depth = null;
    }
  }
  @Watch('product.memberGradeDisplayInfo.info')
  onMemberGradeDisplayInfoChanged() {
    if (this.product.memberGradeDisplayInfo) {
      if (this.product.memberGradeDisplayInfo.info.length === this.grades.length) {
        this.checkGradeAll = true;
      } else {
        this.checkGradeAll = false;
      }
    }
  }
  @Watch('product.minorPurchaseYn')
  private setNonmemberPurchaseYn(value: 'Y' | 'N'){
    this.product.nonmemberPurchaseYn = value !== 'Y';
  }
  clickCheckGroupAll(e: Event) {
    const checked = (e.target as HTMLInputElement).checked;
    if (checked) {
      this.product.memberGroupDisplayInfo.info = [];
      this.groups.forEach(item => {
        this.product.memberGroupDisplayInfo.info.push(item.no);
      });
    } else {
      this.product.memberGroupDisplayInfo.info = [];
    }
  }
  @Watch('product.memberGroupDisplayInfo.info')
  onMemberGroupDisplayInfoChanged() {
    if (this.product.memberGroupDisplayInfo.info.length === this.groups.length) {
      this.checkGroupAll = true;
    } else {
      this.checkGroupAll = false;
    }
  }
  @Watch('product.categoryNo')
  onCategoryNoChanged() {
    // * 미성년자 구매불가 표준 카테고리 선택 시 미성년자구매여부 영향
    if (!this.firstInitDataChange) {
      if (this.product.categoryNo && this.standardCategory.requiresAdultCertification) {
        this.product.minorPurchaseYn = 'N';
        if (this.standardCategory.originType === 'LIQUOR') {
          this.product.nonmemberPurchaseYn = true;
        }
      } else {
        this.product.minorPurchaseYn = 'Y';
      }
    }
  }
  onMinorPurchaseYnChanged(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    // * 미성년자구매여부가 불가능으로 선택되면, 비회원 구매불가 check 및 비활성화
    if (value === 'N') {
      if (!this.product.mallNo) {
        alert(this.$t('PRODUCT_ADD_INPUT_MALL'));
        $('input:radio[name=minorPurchaseYn]')
          .siblings('[value=\'Y\']')
          .prop('checked', true);
        $('#mallNo').focus();
        return false;
      }
      if (!this.useMallAuth) {
        alert(
          '인증 사용 여부를 \'사용 안 함\'으로 설정한 쇼핑몰은\n미성년자 구매 불가능한 상품을 판매할 수 없습니다.\n쇼핑몰 설정 변경 후 상품 등록해 주세요.',
        );
        $('input:radio[name=minorPurchaseYn]')
          .siblings('[value=\'Y\']')
          .prop('checked', true);
      } else {
        this.product.minorPurchaseYn = 'N';
        this.product.nonmemberPurchaseYn = true;
      }
    } else {
      this.product.minorPurchaseYn = 'Y';
    }
  }
  private promotionTextInfoOption = {
    dateType: 'Ymd',
    havePeriodBtn: false,
    name: 'promotionTextInfo',
    fromRanges: getToday(),
  };
  private cartInfoOption = {
    dateType: 'Ymd',
    havePeriodBtn: false,
    name: 'promotionTextInfo',
    fromRanges: getToday(),
  };
  private classTypesDelivery = [
    {
      name: 'PRODUCT_COMMON_CLASS_TYPE_DEFAULT',
      value: 'DEFAULT',
    },
    {
      name: 'PRODUCT_COMMON_CLASS_TYPE_RENTAL',
      value: 'RENTAL',
    },
  ];
  private classTypesService = [
    {
      name: 'PRODUCT_COMMON_CLASS_TYPE_DEFAULT',
      value: 'DEFAULT',
    }
  ];
  private saleMethodTypes = [
    {
      name: 'PRODUCT_COMMON_SALE_METHOD_TYPE_PURCHASE',
      value: 'PURCHASE',
    },
    {
      name: 'PRODUCT_COMMON_SALE_METHOD_TYPE_CONSIGNMENT',
      value: 'CONSIGNMENT',
    },
  ];

  @mallModule.State('malls') private stateMalls!: Mall[];
  get malls() {
    return this.stateMalls;
  }
  
  private get classTypes() {
    return this.product.groupType === 'DELIVERY' && this.product.optionType !== 'MAPPING' ? this.classTypesDelivery : this.classTypesService;
  }

  private displayGuide() {
    this.$emit('displayGuide');
  }
  private checkMall(): boolean {
    if (!this.product.mallNo) {
      alert(this.$t('PRODUCT_ADD_REQUIRE_MALL'));
      $('#mallNo').focus();
      return false;
    }
    return true;
  }

  private filterAdmins(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    this.admin.adminName = value;
    if (value) {
      this.displayAdmins = this.admins.filter(item => {
        return item.name.indexOf(value) > -1;
      });
      if (!this.displayAdmins.length) {
        this.displayAdmins.push({ adminNo: 0, name: this.$t('PRODUCT_ADD_SEARCH_NONE') });
      }
    } else {
      this.displayAdmins = [];
      this.displayAdmins.push({ adminNo: 0, name: this.$t('PRODUCT_ADD_SEARCH_NONE') });
    }
  }

  @Watch('standardCategory.fullCategoryName')
  private setIsBookCategory (value: string) {
    const BOOK = '도서'
    const categoryList = value.split('>')
    this.isBookCategory = categoryList[0] === BOOK
  }

  checkAdmin() {
    const index = this.admins.findIndex(admin => admin.name === this.admin.adminName);
    if (index < 0) {
      this.admin.adminName = '';
    }
  }

  private setAdmin(admin: Mds) {
    if (admin.adminNo !== 0) {
      this.product.adminNo = admin.adminNo;
      this.admin.adminName = admin.name;

      this.displayAdmins = [];
    }
  }
  private resetAdmin() {
    this.product.adminNo = 0;
    this.admin.adminName = '';
    this.displayAdmins = [];
  }
  private filterPartners(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    this.partner.partnerName = value;
    if (value) {
      this.displayPartners = this.partners.filter((item: any) => {
        return item.partnerName.indexOf(value) > -1;
      });
      if (!this.displayPartners.length) {
        this.displayPartners.push({ partnerNo: 0, partnerName: this.$t('PRODUCT_ADD_SEARCH_NONE') });
      }
    } else {
      this.displayPartners = [];
      this.displayPartners.push({ partnerNo: 0, partnerName: this.$t('PRODUCT_ADD_SEARCH_NONE') });
    }
  }
  private setPartner(partner: ContractedPartner) {
    if (partner.partnerNo !== 0) {
      this.product.partnerNo = partner.partnerNo;
      this.$emit('setPartner', partner);
      this.displayPartners = [];
    }
  }
  private resetPartner() {
    this.product.partnerNo = '';
    this.$emit('setPartner', {
      partnerName: '',
    });
    this.displayPartners = [];
  }
  private clickUseStandardCategorySelect() {
    if (this.product.saleStatusType === 'FINISHED') {
      return;
    }
    if (this.checkMall()) {
      this.useStandardCategorySelect = !this.useStandardCategorySelect;
    }
  }
  private clickUseDisplayCategorySelect() {
    if (this.checkMall()) {
      this.useDisplayCategorySelect = !this.useDisplayCategorySelect;
    }
  }
  private filterStandardCategories(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    this.categoryInput = value;
    if (value) {
      this.displayStandardCategories = this.standardCategories.filter(item => {
        return item.fullCategoryName.indexOf(value) > -1;
      });
      if (!this.displayStandardCategories.length) {
        this.displayStandardCategories.push({
          depth4CategoryNo: 0,
          fullCategoryName: this.$t('PRODUCT_ADD_SEARCH_NONE'),
        });
      }
    } else {
      this.displayStandardCategories = [];
      this.displayStandardCategories.push({
        depth4CategoryNo: 0,
        fullCategoryName: this.$t('PRODUCT_ADD_SEARCH_NONE'),
      });
    }
  }
  private setStandardCategory(standardCategory: StandardCategory) {
    if (standardCategory.depth4CategoryNo !== 0) {
      if (this.$route.name === 'EditProduct' && this.product.categoryNo) {
        if (!confirm('등록된 원산지, 인증정보, 카테고리수수료, 미성년자구매여부가 초기화됩니다. 변경하시겠습니까?')) {
          return;
        }
      }
      this.product.categoryNo = standardCategory.depth4CategoryNo;
      this.categoryInput = '';
      this.displayStandardCategories = [];
      this.setCommisionRateByCategory(standardCategory);
    }
  }
  private deleteStandardCategory() {
    if (this.$route.name === 'EditProduct') {
      if (!confirm('등록된 원산지, 인증정보, 카테고리수수료, 미성년자구매여부가 초기화됩니다. 변경하시겠습니까?')) {
        return;
      }
    }
    this.product.categoryNo = 0;
    this.displayStandardCategories = [];
    this.selectedStandardCategory1Depth = null;
    this.selectedStandardCategory2Depth = null;
    this.selectedStandardCategory3Depth = null;
    this.selectedStandardCategory4Depth = null;
  }
  setCommisionRateByCategory(standardCategoriesTree: StandardCategoriesTree | StandardCategory) {
    if (
      this.partner &&
      !(this.partner as ContractedPartner).commissionRate &&
      this.categoryCommissionUseYn &&
      this.product.classType !== 'EVENT'
    ) {
      this.product.commissionInfo.type = 'CATEGORY';
      this.product.commissionInfo.rate = standardCategoriesTree.commissionRate;
    }
  }
  private setStandardCategoryDepth(depth: number, standardCategoriesTree: StandardCategoriesTree) {
    if (depth === 1) {
      this.selectedStandardCategory1Depth = standardCategoriesTree;
      this.selectedStandardCategory2Depth = null;
      this.selectedStandardCategory3Depth = null;
      this.selectedStandardCategory4Depth = null;
      if (!(this.selectedStandardCategory1Depth.child as StandardCategoriesTree[]).length) {
        if (this.$route.name === 'EditProduct' && this.product.categoryNo) {
          if (!confirm('등록된 원산지, 인증정보, 카테고리수수료, 미성년자구매여부가 초기화됩니다. 변경하시겠습니까?')) {
            this.selectedStandardCategory1Depth = null;
            return;
          }
        }
        this.product.categoryNo = standardCategoriesTree.categoryNo;
        this.setCommisionRateByCategory(standardCategoriesTree);
      }
    }
    if (depth === 2) {
      this.selectedStandardCategory2Depth = standardCategoriesTree;
      this.selectedStandardCategory3Depth = null;
      this.selectedStandardCategory4Depth = null;
      if (!(this.selectedStandardCategory2Depth.child as StandardCategoriesTree[]).length) {
        if (this.$route.name === 'EditProduct' && this.product.categoryNo) {
          if (!confirm('등록된 원산지, 인증정보, 카테고리수수료, 미성년자구매여부가 초기화됩니다. 변경하시겠습니까?')) {
            this.selectedStandardCategory2Depth = null;
            return;
          }
        }
        this.product.categoryNo = standardCategoriesTree.categoryNo;
        this.setCommisionRateByCategory(standardCategoriesTree);
      }
    }
    if (depth === 3) {
      this.selectedStandardCategory3Depth = standardCategoriesTree;
      this.selectedStandardCategory4Depth = null;
      if (!(this.selectedStandardCategory3Depth.child as StandardCategoriesTree[]).length) {
        if (this.$route.name === 'EditProduct' && this.product.categoryNo) {
          if (!confirm('등록된 원산지, 인증정보, 카테고리수수료, 미성년자구매여부가 초기화됩니다. 변경하시겠습니까?')) {
            this.selectedStandardCategory3Depth = null;
            return;
          }
        }
        this.product.categoryNo = standardCategoriesTree.categoryNo;
        this.setCommisionRateByCategory(standardCategoriesTree);
      }
    }
    if (depth === 4) {
      if (this.$route.name === 'EditProduct' && this.product.categoryNo) {
        if (!confirm('등록된 원산지, 인증정보, 카테고리수수료, 미성년자구매여부가 초기화됩니다. 변경하시겠습니까?')) {
          return;
        }
      }
      this.selectedStandardCategory4Depth = standardCategoriesTree;
      this.product.categoryNo = standardCategoriesTree.categoryNo;
      this.setCommisionRateByCategory(standardCategoriesTree);
    }
  }

  @Watch('product.mallNo')
  private get hasNotDisplayCategoriesByMall(){
    return this.product.mallNo && !this.displayCategories.length
  }
  private filterDisplayCategories(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    this.displayCategoryInput = value;
    if (value) {
      this.displayDisplayCategories = this.displayCategories.filter(item => {
        return item.fullCategoryName.indexOf(value) > -1;
      });
      if (!this.displayDisplayCategories.length) {
        this.displayDisplayCategories.push({
          depth5DisplayCategoryNo: 0,
          fullCategoryName: this.$t('PRODUCT_ADD_SEARCH_NONE'),
        });
      }
    } else {
      this.displayDisplayCategories = [];
      this.displayDisplayCategories.push({
        depth5DisplayCategoryNo: 0,
        fullCategoryName: this.$t('PRODUCT_ADD_SEARCH_NONE'),
      });
    }
  }
  private setDisplayCategory(displayCategory: DisplayCategoriesView) {
    if (displayCategory.depth5DisplayCategoryNo !== 0) {
      this.product.displayCategoryNos.push(displayCategory.depth5DisplayCategoryNo);
      this.displayCategoryNames.push({
        name: displayCategory.fullCategoryName,
        display: displayCategory.depth5Displayable ? 'Y' : 'N',
      });
      this.displayCategoryInput = '';
      this.displayDisplayCategories = [];
    }
  }
  private deleteDisplayCategory(index: number) {
    this.product.displayCategoryNos.splice(index, 1);
    this.displayCategoryNames.splice(index, 1);
    this.displayDisplayCategories = [];
  }
  private setDisplayCategoryDepth(depth: number, displayCategoriesTree: DisplayCategoriesTree) {
    if (depth === 1) {
      this.selectedDisplayCategory1Depth = displayCategoriesTree;
      this.selectedDisplayCategory2Depth = null;
      this.selectedDisplayCategory3Depth = null;
      this.selectedDisplayCategory4Depth = null;
      this.selectedDisplayCategory5Depth = null;
      if (
        !displayCategoriesTree.children.length &&
        this.product.displayCategoryNos.indexOf(displayCategoriesTree.displayCategoryNo) === -1
      ) {
        this.displayCategoryNames.push({
          name: displayCategoriesTree.displayCategoryName,
          display: displayCategoriesTree.displayYn,
        });
        this.product.displayCategoryNos.push(displayCategoriesTree.displayCategoryNo);
      }
    }
    if (depth === 2) {
      this.selectedDisplayCategory2Depth = displayCategoriesTree;
      this.selectedDisplayCategory3Depth = null;
      this.selectedDisplayCategory4Depth = null;
      this.selectedDisplayCategory5Depth = null;
      if (
        !displayCategoriesTree.children.length &&
        this.product.displayCategoryNos.indexOf(displayCategoriesTree.displayCategoryNo) === -1
      ) {
        this.displayCategoryNames.push({
          name: `${(this.selectedDisplayCategory1Depth as DisplayCategoriesTree).displayCategoryName}>${
            displayCategoriesTree.displayCategoryName
          }`,
          display: displayCategoriesTree.displayYn,
        });
        this.product.displayCategoryNos.push(displayCategoriesTree.displayCategoryNo);
      }
    }
    if (depth === 3) {
      this.selectedDisplayCategory3Depth = displayCategoriesTree;
      this.selectedDisplayCategory4Depth = null;
      this.selectedDisplayCategory5Depth = null;
      if (
        !displayCategoriesTree.children.length &&
        this.product.displayCategoryNos.indexOf(displayCategoriesTree.displayCategoryNo) === -1
      ) {
        this.displayCategoryNames.push({
          name: `${(this.selectedDisplayCategory1Depth as DisplayCategoriesTree).displayCategoryName}>${
            (this.selectedDisplayCategory2Depth as DisplayCategoriesTree).displayCategoryName
          }>${displayCategoriesTree.displayCategoryName}`,
          display: displayCategoriesTree.displayYn,
        });
        this.product.displayCategoryNos.push(displayCategoriesTree.displayCategoryNo);
      }
    }
    if (depth === 4) {
      this.selectedDisplayCategory4Depth = displayCategoriesTree;
      this.selectedDisplayCategory5Depth = null;
      if (
        !displayCategoriesTree.children.length &&
        this.product.displayCategoryNos.indexOf(displayCategoriesTree.displayCategoryNo) === -1
      ) {
        this.displayCategoryNames.push({
          name: `${(this.selectedDisplayCategory1Depth as DisplayCategoriesTree).displayCategoryName}>${
            (this.selectedDisplayCategory2Depth as DisplayCategoriesTree).displayCategoryName
          }>${(this.selectedDisplayCategory3Depth as DisplayCategoriesTree).displayCategoryName}>${
            displayCategoriesTree.displayCategoryName
          }`,
          display: displayCategoriesTree.displayYn,
        });
        this.product.displayCategoryNos.push(displayCategoriesTree.displayCategoryNo);
      }
    }
    if (depth === 5) {
      this.selectedDisplayCategory5Depth = displayCategoriesTree;
      if (
        !displayCategoriesTree.children.length &&
        this.product.displayCategoryNos.indexOf(displayCategoriesTree.displayCategoryNo) === -1
      ) {
        this.displayCategoryNames.push({
          name: `${(this.selectedDisplayCategory1Depth as DisplayCategoriesTree).displayCategoryName}>${
            (this.selectedDisplayCategory2Depth as DisplayCategoriesTree).displayCategoryName
          }>${(this.selectedDisplayCategory3Depth as DisplayCategoriesTree).displayCategoryName}>${
            (this.selectedDisplayCategory4Depth as DisplayCategoriesTree).displayCategoryName
          }>${displayCategoriesTree.displayCategoryName}`,
          display: displayCategoriesTree.displayYn,
        });
        this.product.displayCategoryNos.push(displayCategoriesTree.displayCategoryNo);
      }
    }
  }
  private searchBrand = debounce((e:Event) => this.searchBrandsByKeyword(e), 500);
  private async searchBrandsByKeyword(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    this.brand.brandName = value

    if (this.brand.brandName) {
      await this.fetchBrandsSearch();
      this.setDisplayBrands();
      if (!this.displayBrands.length) {
        this.displayBrands.push({ brandNo: 0, brandName: this.$t('PRODUCT_ADD_SEARCH_NONE') });
      }
    } else {
      this.displayBrands = [];
      this.displayBrands.push({ brandNo: 0, brandName: this.$t('PRODUCT_ADD_SEARCH_NONE') });
    }
  }

  private async fetchBrandsSearch() {
    if (!this.product.mallNo || !this.brand.brandName.length) return;

    const params: GetBrandsSearchRequest = { params: { mallNo: Number(this.product.mallNo), keyword: this.brand.brandName } };
    const { data }: NCPResponse<Brand[]> = await this.$api.getBrandsSearch(params);
    this.brands = data;
  }

  @Watch('brands')
  private setDisplayBrands() {
    this.displayBrands = this.brands.filter(item => item.brandName.indexOf(this.brand.brandName) > -1);
  }

  private setBrand(brand: Brand) {
    if (brand.brandNo !== 0) {
      this.product.brandName = brand.brandName;
      this.brand.brandName = brand.brandName;
      this.brand.brandNo = brand.brandNo;
      this.displayBrands = [];
    }
  }
  private resetBrand() {
    this.brand.selfInput = false;
    this.product.brandName = '';
    this.brand.brandNo = undefined;
    this.brand.brandName = '';
    this.displayBrands = [];
  }

  private changedUseRelatedProductStatus(curr: keyof typeof CONFIG_TYPE) {
    if (curr !== CONFIG_TYPE.NOT_USED && !this.product.mallNo) {
      this.checkMall();
      this.$nextTick(() => {
        this.relatedProductInfoSync.configType = CONFIG_TYPE.NOT_USED;
      });
    }
    if (curr === CONFIG_TYPE.DISPLAY_CATEGORY) {
      this.$set(this.relatedProductInfoSync, 'sortCriterion', SORT_CRITERION.LATEST_REGISTER_DATE);
    }
  }

  getHTML(name: string, input: string) {
    const arr = name.split(input);
    return arr.join(`<span>${input}</span>`);
  }

  getAdminHTML(name: string, id:string, input: string) {
    const adminNames = name === this.$t('PRODUCT_ADD_SEARCH_NONE')
      ? name.split(input)
      : (`${name}(${id})`).split(input);

    return adminNames.join(`<span>${input}</span>`);
  }

  private saleMethodTypeChange() {
    //* SA: 사입(df)/위탁, BPC: 위탁(df)
    //* 사입(공급가), 위탁(매입가)
    if (this.product.saleMethodType === 'PURCHASE') {
      this.product.purchasePrice = 0;
      this.product.partnerChargeAmt = 0;
      this.product.commissionInfo.type = 'PRODUCT';
      this.product.commissionInfo.rate = 0;
    }
  }
  selfInput() {
    const value = $('#newBrandName').val();
    this.brand.selfInput = true;
    this.brand.brandName = value;
    this.product.brandName = value;
    this.displayBrands = [];
  }
  brandClickOutSide() {
    this.displayBrands = [];
    if (!this.brand.selfInput && !this.brand.brandNo) {
      this.brand.brandName = '';
    }
  }

  private get textLength() {
    return this.product.productName.length ?? 0; 
  }
  
  handleProductName(e: Event) {
    const value = (e.target as HTMLInputElement).value.trim();

    this.product.productName = this.regex.test(value) ? '' : value;
  }

  @Watch('product.groupType')
  onGroupTypeChanged(newVal: string) {
    if (newVal === 'SERVICE') {
      this.product.classType = 'DEFAULT';
    }
  }

  @Watch('product.paymentMeansControlYn')
  onPaymentMeansControlYnChanged(newVal: string) {
    if (newVal === 'N') {
      this.product.cartInfo.useYn = 'Y';
    } else {
      this.product.cartInfo.useYn = 'N';
    }
  }
  changeMall(e: Event) {
    const value = Number((e.target as HTMLInputElement).value);
    const oldVal = this.product.mallNo;
    // * 옵션 등록되어있는 상태에서 쇼핑몰 변경 시 얼럿출력
    // * “쇼핑몰 변경 시 옵션정보는 초기화 됩니다. 변경하시겠습니까?”
    if (this.product.options.length) {
      if (confirm(this.$t('PRODUCT_ADD_OPTION_RESET_CONFIRM') as string)) {
        this.product.mallNo = value;
        this.$emit('changedMall');
      } else {
        this.$nextTick().then(() => {
          this.product.mallNo = oldVal;
        });
      }
    } else {
      this.product.mallNo = value;
      this.$emit('changedMall');
    }
  }
  onClassTypeChanged(e: Event) {
    const newVal = (e.target as HTMLInputElement).value;
    const oldVal = this.product.classType;
    // * 이벤트상품 선택시 영향범위
    if (newVal === 'EVENT') {
      if (this.product.options.length) {
        if (confirm('옵션이 초기화됩니다.')) {
          this.product.classType = newVal;
          this.product.optionType = 'DEFAULT';
          this.product.options = [];
          this.initByClassTypeChang();
        } else {
          this.$nextTick().finally(() => {
            this.product.classType = oldVal;
          });
        }
      } else {
        this.product.classType = newVal;
        this.initByClassTypeChang();
      }
    }
    if (newVal === 'RENTAL') {
      this.product.paymentMeansControlYn = 'Y';
      this.product.paymentMeans = ['RENTAL'];
      this.product.reservationUseYn = 'N';
      this.product.accumulationUseYn = 'N';
      this.product.promotionInfo.couponYn = false;
      this.product.promotionInfo.freeGiftYn = 'N';
      this.product.deliveryCombinationYn = true;
    }
    if (oldVal === 'RENTAL' && newVal !== 'RENTAL') {
      this.product.paymentMeansControlYn = 'N';
      this.product.extraJson.manufactureName = '';
      this.product.extraJson.productModelName = '';
      this.product.extraJson.serialNumber = '';
    }
    this.product.classType = newVal;
  }
  initByClassTypeChang() {
    //* 상품유형
    //* SA만 상품 유형 설정 가능

    // * 이벤트상품 사용 용도: 판매가 0원 상품으로 고객이 구매 시 PG 사에 데이터를 전송하지 않음, 이벤트 상품의 판매 진행 및 고객 데이터 취합 목적으로 사용 될 수 있음
    // * 판매가, 즉시할인 입력불가- 판매가 0원 고정 출력 (변경불가)
    this.product.salePrice = 0;
    this.product.unitPriceYn = false;
    // * 적립금적립,적립금사용: {{$t('COMMON_NOT_SET')}}(변경X)
    this.product.accumulationSaveYn = 'N';
    this.product.accumulationUseYn = 'N';
    // * 가격비교사이트: 등록안함(변경X)
    // * 즉시할인 초기화
    this.product.immediateDiscountInfo = {
      unitType: 'AMOUNT',
      startYmdt: getToday(),
      amount: 0,
      endYmdt: addMonth(new Date(), 3, '-'),
      periodYn: false,
    };
    this.product.comparingPriceSiteInfo = {
      check: 'NONE',
      info: [],
    };
    // * 배송여부 : 배송안함으로 초기화, 변경 가능.
    if (this.product.optionType !== 'MAPPING') {
      this.product.deliveryYn = 'N';
    }
    this.product.commissionInfo = {
      type: 'PRODUCT',
      rate: 0,
    };

    this.product.partnerChargeAmt = 0;
  }
  clickMemberGradeDisplayY() {
    this.product.memberGradeDisplayInfo.info = this.grades.map(grade => grade.no);
  }
  clickMemberGroupDisplayY() {
    this.product.memberGroupDisplayInfo.info = this.groups.map(group => group.no);
  }
}
